import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const ProfessionalTaxIndia = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />
      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        Professional Tax
      </div>
      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        Professional Tax, a state government levy in India, is a tax on income
        from trades and employments, collected by employers and remitted to state
        or local authorities, with a current annual cap of Rs. 2500.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Legislative Origin */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Legislative Origin
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
                marginBottom: isMobile ? "5px" : "10px",
              }}
            ></div>
          </div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Professional Tax, distinct from income tax managed by the central
            government, was initially capped at Rs. 250, with an upward revision
            to Rs. 2500 to bolster state revenue resources.
          </p>

          {/* Tax Structure */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Tax Structure
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The maximum annual tax is Rs. 2500, deducted monthly by employers based
            on the employee’s gross income, with applicable states including
            Karnataka, West Bengal, Andhra Pradesh, Maharashtra, Tamil Nadu,
            Gujarat, Assam, Chhattisgarh, Kerala, Meghalaya, Odisha, Tripura, and
            Madhya Pradesh.
          </p>

          {/* Payment Obligation */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Payment Obligation
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Employers deduct the tax from salaries or wages and deposit it with
            the state government, ensuring compliance with local tax regulations.
          </p>

          {/* Registration Process */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Registration Process
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Businesses must register with the State Tax Department within 30 days
            of employing staff, submitting separate applications for multiple work
            locations under respective authorities’ jurisdictions.
          </p>

          {/* Penalty Provisions */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Penalty Provisions
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Late registration incurs a Rs. 5 daily penalty, while late payment or
            non-filing of returns attracts a 10% tax penalty or a Rs. 300 fine,
            varying by state.
          </p>

          {/* State Variations */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            State Variations
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            As a state levy, Professional Tax differs across states with unique
            slabs, and several states and union territories do not impose it,
            reflecting regional policy differences.
          </p>

          {/* Payment Schedule */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Payment Schedule
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The tax is paid in 12 equal monthly installments, with separate
            liabilities for income from diverse sectors requiring individual tax
            assessments.
          </p>

          {/* Taxable Entities */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Taxable Entities
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Applicable to companies, firms, LLPs, corporations, societies, HUFs,
            associations, clubs, and professionals like legal practitioners,
            contractors, architects, engineers, insurance agents, chartered
            accountants, company secretaries, surveyors, tax consultants,
            management professionals, and medical representatives.
          </p>

          {/* Exemption Categories */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Exemption Categories
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Exemptions apply to ex-servicemen, Central Para Military Force members,
            educators up to class 12, individuals with 40%+ disability (with
            certificate), single three-wheeler/taxi permit holders,
            deaf/dumb/blind salaried individuals, armed forces members, and
            foreign technicians employed by the state.
          </p>

          {/* Compliance Oversight */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Compliance Oversight
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            State tax departments monitor compliance, imposing penalties for
            non-registration, late payments, or delayed return filings, with
            enforcement varying by state regulations.
          </p>

          {/* Concluding Overview */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Concluding Overview
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Professional Tax in India, administered by state governments, requires
            timely registration and payment, with exemptions and penalties
            tailored to regional policies and compliance levels.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ProfessionalTaxIndia;